import axios, { resHandle } from "@/plugins/axios";

/**
 * @description 获取项目报告总数据
 * @param vCom Vue组件
 */
const GetReportData = (vCom: any, params?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/report/overview", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取分中心病例数量统计
 * @param vCom Vue组件
 */
const PostFenzhongxinBingli = (vCom: any, params?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/report/fzx ", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取研究小组病例数量统计
 * @param vCom Vue组件
 */
const PostYanjiuxiaozuBingli = (vCom: any, params?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/report/yjz", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取研究者病例数量统计
 * @param vCom Vue组件
 */
const PostYanjiuzheBingli = (vCom: any, params?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/report/user", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取分中心数据质量
 * @param vCom Vue组件
 */
const PostFenzhongxinShujizhiliang = (vCom: any, params?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/zhenci/fzx", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取研究者小组数据质量
 * @param vCom Vue组件
 */
const PostyanjiuzuShujizhiliang = (vCom: any, params?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/zhenci/yjz", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取研究者者数据质量
 * @param vCom Vue组件
 */
const PostyanjiuzheShujizhiliang = (vCom: any, params?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/zhenci/user", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取分中心失活原因
 * @param vCom Vue组件
 */
const PostfenzhongxinShihuo = (vCom: any, params?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/inactive/fzx", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取审核者失活原因
 * @param vCom Vue组件
 */
const PostshenhezheShihuo = (vCom: any, params?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/inactive/user", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};



export {
    GetReportData, PostFenzhongxinBingli, PostYanjiuxiaozuBingli, PostYanjiuzheBingli, PostFenzhongxinShujizhiliang,
    PostyanjiuzuShujizhiliang, PostyanjiuzheShujizhiliang, PostfenzhongxinShihuo, PostshenhezheShihuo
};
